// Overnights — backdated/snapshot analogue of NOP + LP Accounts.
// Services: /api/app/backdated-nop and /api/app/backdated-lp-account (ABP strips Get).
export interface NopLoginDetailDto {
  login: number;
  platformId: number;
  platform: string;
  uniqueId: string;
  netVolume: number;
  pnl: number;
  originalPnl: number;
  baseNotional: number | null;
  averagePrice: number;
  concentration: number | null;
}

export interface NopSnapshotDto {
  id: number;
  symbol: string;
  netVolume: number;
  openPrice: number;
  floatingPnl: number;
  lastPrice: number;
  datasourceName: string;
  concentration: number;
  dataSourceId: number;
  digits: number;
  loginDetails: NopLoginDetailDto[];
}

export interface NopSnapshotTotalsDto {
  totalNetVolume: number;
  totalFloatingPnl: number;
}

export interface NopDailySnapshotListDto {
  id: number;
  snapshotAt: string;
  tradesStatus: boolean;
  dataSourceConversionsStatus: boolean;
  dataSourcePricesStatus: boolean;
  prerequisitesMet: boolean;
}

export interface NopSnapshotNotificationsDto {
  missingSymbolsNotification: string;
  missingSymbols: string[];
  hasMissingSymbols: boolean;
}

export type HedgeStatusValue = 0 | 1 | 2 | 3;
export type TradeActionValue = 0 | 1 | 2;
export interface VolumeMatchingItemDto {
  symbol: string;
  clientNetVolume: number;
  lpNetVolume: number;
  hedgeStatus: HedgeStatusValue;
  tradeToBalance: number;
  action: TradeActionValue;
  isBreach: boolean;
}

export interface DailySnapshotListDto {
  id: number;
  snapshotAt: string;
  lpAccountStatus: boolean;
}
export interface LPAccountSnapshotDto {
  serverName: string;
  login: number;
  accountCurrency: string;
  balanceRc: number;
  creditRc: number;
  floatingRc: number;
  equityRc: number;
  marginUsedRc: number;
  freeMarginRc: number;
  marginLevel: number;
  riskyVol: number;
  dataSourceName: string;
  serverTime: string;
  isMissing: boolean;
  platformId: number;
}
export interface LPAccountTotalsDto {
  totalBalanceRc: number;
  totalCreditRc: number;
  totalFloatingRc: number;
  totalEquityRc: number;
  totalMarginUsedRc: number;
  totalFreeMarginRc: number;
  averageMarginLevel: number;
  totalRiskyVol: number;
}
export interface LpEodPositionDto {
  order: number;
  login: number;
  uniqueId: string;
  type: string;
  volumeMT: number;
  instrument: string;
  openPrice: number;
  openTime: string;
  baseNotionalRc: number;
  server: string;
}

export const NopType = { ClientsNOP: 0, RTNOP: 1, FirmNOP: 2, LPNOP: 3 } as const;

export interface NopSnapshotQuery {
  snapshotId: number;
  nopType: number;
  isAutoMapping?: boolean;
  byUniqueId?: boolean;
  symbolMapping?: boolean;
  login?: string | null;
  datasourceId?: string | null;
  instrument?: string | null;
  mifidFilter?: string | null;
  groupName?: string | null;
  portfolioId?: number | null;
  skipCount?: number;
  maxResultCount?: number;
}
